<template>
	<div>
		<span v-if="row.item.status === 'Open'">
			<b-badge variant="secondary">{{ row.item.status }}</b-badge>
		</span>
		<span v-if="row.item.status === 'In-Repair'">
			<b-badge variant="success">{{ row.item.status }}</b-badge>
		</span>
		<span v-if="row.item.status === 'Closed'">
			<b-badge variant="light">{{ row.item.status }}</b-badge>
		</span>
		<span v-if="row.item.status === 'Cancelled'">
			<b-badge variant="danger">{{ row.item.status }}</b-badge>
		</span>
	</div>
</template>

<script>
export default {
	name: 'dispatch-row-status',
	props: {
		row: {
			type: Object,
			required: true
		}
	}
};
</script>

<style>

</style>

